import React from "react";
import GlobalSearchBox from "../components/GlobalSearchBox";

export default function SearchPage() {
  return (
    <div className="p-4 md:p-6">
      <div className="max-w-3xl">
        <h1 className="text-xl font-semibold text-gray-100">Search</h1>
        <p className="text-sm text-gray-400 mt-1">
          Cari saham, industri, konglo, broker, dan chat.
        </p>

        <GlobalSearchBox className="mt-4" autoFocus />

        {/* Nanti di bawah ini baru kita taruh sections:
            - Heatmap saham
            - Top 9 Industri
            - Top 9 Konglo
            - Top 9 Broker Activity
        */}
        <div className="mt-6 text-sm text-gray-500">
          Sections (heatmap/top lists) menyusul setelah Global Search selesai.
        </div>
      </div>
    </div>
  );
}
